import { Color, Spacing } from '@persona-id/design-tokens';
import { zip } from 'lodash/fp';
import { ReactElement } from 'react';
import styled from 'styled-components';

import AsyncImage from 'dashboard/components-lib/AsyncImage';
import { FontWeight } from 'design-system/variables/text';

const Container = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${Spacing[4]};
`;

const ColumnContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Spacing[4]};
`;

const Description = styled('div')`
  margin-bottom: ${Spacing[4]};
`;

const PhotoLabel = styled('p')`
  color: ${Color.CoreSlate1000};
  font-weight: ${FontWeight.Medium};
  margin-top: ${Spacing[2]};
`;

interface ImagesComparisonProps {
  leftImagesUrls: string[];
  rightImagesUrls: string[];
  leftImagesFooterTexts?: string[];
  rightImagesFooterTexts?: string[];
  description?: string;
}

const ImagesComparison = ({
  description,
  leftImagesUrls,
  rightImagesUrls,
  leftImagesFooterTexts,
  rightImagesFooterTexts,
}: ImagesComparisonProps): ReactElement => {
  return (
    <>
      <Description>{description}</Description>
      <Container>
        <ColumnContainer>
          {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
          {zip(leftImagesUrls, leftImagesFooterTexts).map(([imageUrl, footerText]) => (
            <div key={imageUrl}>
              <AsyncImage
                imageUrl={imageUrl}
                width='600px'
                height='375px'
                allowPreviewZoom={false}
              />
              <PhotoLabel>{footerText}</PhotoLabel>
            </div>
          ))}
        </ColumnContainer>
        <ColumnContainer>
          {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
          {zip(rightImagesUrls, rightImagesFooterTexts).map(([imageUrl, footerText]) => (
            <div key={imageUrl}>
              <AsyncImage
                imageUrl={imageUrl}
                width='600px'
                height='375px'
                allowPreviewZoom={false}
              />
              <PhotoLabel>{footerText}</PhotoLabel>
            </div>
          ))}
        </ColumnContainer>
      </Container>
    </>
  );
};

export default ImagesComparison;
